export default __webpack_public_path__ + "static/media/1.9f2533c2.png";